// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxlr7P64NuNqxDz7T5v018xjQEvse_bA8",
  authDomain: "siliconminds-7fb5c.firebaseapp.com",
  databaseURL: "https://siliconminds-7fb5c-default-rtdb.firebaseio.com",
  projectId: "siliconminds-7fb5c",
  storageBucket: "siliconminds-7fb5c.firebasestorage.app",
  messagingSenderId: "8132019201",
  appId: "1:8132019201:web:76ce8721a4b0bbc86cac00",
  measurementId: "G-CN8Z1ZZ3QE"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

const firebaseApp = initializeApp(firebaseConfig);

export default firebaseConfig;
